import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SUB_PRACTICE_LIST = 'GET_SUB_PRACTICE_LIST';
export const GET_SUB_PRACTICE_LIST_SUCCESS = 'GET_SUB_PRACTICE_LIST_SUCCESS';
export const GET_SUB_PRACTICE_LIST_FAILURE = 'GET_SUB_PRACTICE_LIST_FAILURE';

// Action Creators
export const getSubPractice = () => ({
  type: GET_SUB_PRACTICE_LIST,
});

export const getSubPracticeSuccess = (users) => ({
  type: GET_SUB_PRACTICE_LIST_SUCCESS,
  payload: users,
});

export const getSubPracticeFailure = (error) => ({
  type: GET_SUB_PRACTICE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSubPracticeList = (external) => {
  return async (dispatch) => {
    dispatch(getSubPractice());
    try {
      const response = await getMethodWithToken(url.getSubPractice);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSubPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSubPracticeFailure(error?.message));
    }
  };
};
